// extracted by mini-css-extract-plugin
export default {"buildCard":"S99B7Mww5HYWI7eOWyPw","successfulBuild":"lq8U4u7B6O7Vb4VbzzWq","failedBuild":"k1ZAdf0tuf6JyODiZe3t","buildTimeSection":"pAmwWRlSZ58C80VY2cA4"};